import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EdgeOfflineModule } from "src/app/shared/components/edge/offline/offline.module";
import { HelpButtonComponent } from "src/app/shared/components/modal/help-button/help-button";
import { ModalModule } from "src/app/shared/components/modal/modal.module";
import { SharedModule } from "../../shared/shared.module";
import { Controller_Ess_FixActivePower } from "../live/Controller/Ess/FixActivePower/Ess_FixActivePower";
import { Common_Autarchy } from "./common/autarchy/Common_Autarchy";
import { CommonConsumption } from "./common/consumption/common-consumption";
import { CurMonthProductionComponent } from "./common/curmonthproduction/curmonthproduction.component";
import { Common_DayProduction } from "./common/dayproduction/Common_DayProduction";
import { Common_Logo } from "./common/logo/Common_Logo";
import { Common_Logos } from "./common/logos/Common_Logos";
import { PreMonthProductionComponent } from "./common/premonthproduction/premonthproduction.component";
import { Common_Production } from "./common/production/Common_Production";
import { ReducedEmissionComponents } from "./common/reducedgas/ReducedEmissionComponents";
import { Common_Sensor } from "./common/sensor/Common_Sensor";
import { StorageModalComponent } from "./common/storage/modal/modal.component";
import { StorageComponent } from "./common/storage/storage.component";
import { WeatherModule } from "./common/weather/weather.module";
import { YearProductionComponent } from "./common/yearproduction/yearproduction.component";
import { YearReducedgasComponent } from "./common/yearreducedgas/yearreducedgas.component";
import { AdministrationComponent } from "./Controller/Evcs/administration/administration.component";
import { Controller_Evcs } from "./Controller/Evcs/Evcs";
import { Controller_Asymmetric_PeakShavingComponent } from "./Controller/PeakShaving/Asymmetric/Asymmetric";
import { Controller_Asymmetric_PeakShavingModalComponent } from "./Controller/PeakShaving/Asymmetric/modal/modal.component";
import { Controller_Symmetric_PeakShavingModalComponent } from "./Controller/PeakShaving/Symmetric/modal/modal.component";
import { Controller_Symmetric_PeakShavingComponent } from "./Controller/PeakShaving/Symmetric/Symmetric";
import { Controller_Symmetric_TimeSlot_PeakShavingModalComponent } from "./Controller/PeakShaving/Symmetric_TimeSlot/modal/modal.component";
import { Controller_Symmetric_TimeSlot_PeakShavingComponent } from "./Controller/PeakShaving/Symmetric_TimeSlot/Symmetric_TimeSlot";
import { EnergymonitorModule } from "./energymonitor/energymonitor.module";
import { InfoComponent } from "./info/info.component";
import { EvcsChartComponent } from "./Multiple/Evcs_Api_Cluster/modal/evcs-chart/evcs.chart";
import { NavigationInfoComponent } from "./navigation-info/navigation-info";
import { SignageComponent } from "./signage.component";
@NgModule({
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        Common_Autarchy,
        CommonConsumption,
        Common_Production,
        Common_DayProduction,
        Common_Sensor,
        Common_Logo,
        Common_Logos,
        Controller_Ess_FixActivePower,
        ReducedEmissionComponents,
        EnergymonitorModule,
        WeatherModule,
        ModalModule,
        SharedModule,
        Controller_Evcs,
        EdgeOfflineModule,
        HelpButtonComponent,
    ],
    declarations: [
        AdministrationComponent,
        NavigationInfoComponent,
        Controller_Asymmetric_PeakShavingComponent,
        Controller_Asymmetric_PeakShavingModalComponent,
        Controller_Symmetric_PeakShavingComponent,
        Controller_Symmetric_PeakShavingModalComponent,
        Controller_Symmetric_TimeSlot_PeakShavingComponent,
        Controller_Symmetric_TimeSlot_PeakShavingModalComponent,
        EvcsChartComponent,
        InfoComponent,
        SignageComponent,
        CurMonthProductionComponent,
        PreMonthProductionComponent,
        YearProductionComponent,
        YearReducedgasComponent,
        StorageComponent,
        StorageModalComponent,
    ],
})
export class SignageModule { }
